import React, { useState } from 'react';

/**
 * Компактная версия кнопки для размещения внутри строки таблицы
 */
export const AddRowButtonCompact = ({ onClick, disabled = false, colSpan = 1 }) => {
  const [isHovered, setIsHovered] = useState(false);

  if (disabled) return null;

  return (
    <tr>
      <td 
        colSpan={colSpan}
        style={{ 
          padding: 0,
          border: '1px solid var(--border-color)',
          backgroundColor: isHovered ? 'rgba(0, 123, 255, 0.05)' : 'var(--table-stripe)'
        }}
      >
        <button
          type="button"
          data-testid="schedule-add-row"
          onClick={onClick}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          style={{
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '8px',
            padding: '12px 16px',
            fontSize: '14px',
            fontWeight: '500',
            color: isHovered ? '#007bff' : '#6c757d',
            backgroundColor: 'transparent',
            border: 'none',
            cursor: 'pointer',
            transition: 'all 0.2s ease'
          }}
        >
          <span style={{ 
            width: '24px',
            height: '24px',
            borderRadius: '50%',
            backgroundColor: isHovered ? '#007bff' : '#e9ecef',
            color: isHovered ? '#fff' : '#6c757d',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '16px',
            fontWeight: 'bold',
            transition: 'all 0.2s ease'
          }}>
            +
          </span>
          <span>Добавить новую строку</span>
        </button>
      </td>
    </tr>
  );
};
